// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-02-25T08:47:36Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 *  Generated from cz.marbes.eosp.controller.SpravaKontaktuController.
 */
export default class SpravaKontaktuApi {
    /**
     * Update kontaktu, která se povede pouze pokud je předán správný ověřovací kód. @param kontaktKodVO kontakt + ověřovací kód @return výsledek
     *
     * @param kontaktKodVO 
     * @return cz.marbes.eosp.controller.vo.TwoFactorOperationVO
     */
    static updateOvereniEmailKod(kontaktKodVO) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/email/update`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kontaktKodVO, headers));
    }

    /**
     * 
     *
     * @param overeniVO 
     * @return cz.marbes.eosp.controller.vo.TwoFactorOperationVO
     */
    static getOvereniEmailKod(overeniVO) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/email/get`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, overeniVO, headers));
    }

    /**
     * 
     *
     */
    static enableNotifikaceEmail() {
        const uri = serverContextPath + `/api/spravauctu/kontakty/notifikace/email/enable`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Update kontaktu, která se povede pouze pokud je předán správný ověřovací kód. @param kontaktKodVO kontakt + ověřovací kód @return výsledek
     *
     * @param kontaktKodVO 
     * @return cz.marbes.eosp.controller.vo.TwoFactorOperationVO
     */
    static updateOvereniTelefonKod(kontaktKodVO) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/telefon/update`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kontaktKodVO, headers));
    }

    /**
     * 
     *
     */
    static disableHromadneOsloveni() {
        const uri = serverContextPath + `/api/spravauctu/kontakty/notifikace/hromadne-osloveni/disable`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * 
     *
     */
    static disableNotifikaceTelefon() {
        const uri = serverContextPath + `/api/spravauctu/kontakty/notifikace/telefon/disable`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Update kontaktu. @param kontakt kontakt
     *
     * @param kontakt 
     */
    static updateTelefon(kontakt) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/telefon/edit`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kontakt, headers));
    }

    /**
     * Update kontaktu. @param kontakt kontakt
     *
     * @param kontakt 
     */
    static updateEmail(kontakt) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/email/edit`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kontakt, headers));
    }

    /**
     * 
     *
     * @param repeatRequestCode 
     * @return cz.marbes.eosp.controller.vo.TwoFactorOperationVO
     */
    static repeatEmail(repeatRequestCode) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/email/repeat`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, repeatRequestCode, headers));
    }

    /**
     * 
     *
     * @param repeatRequestCode 
     * @return cz.marbes.eosp.controller.vo.TwoFactorOperationVO
     */
    static repeatTelefon(repeatRequestCode) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/telefon/repeat`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, repeatRequestCode, headers));
    }

    /**
     * 
     *
     */
    static disableNotifikaceEmail() {
        const uri = serverContextPath + `/api/spravauctu/kontakty/notifikace/email/disable`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * 
     *
     */
    static enableNotifikaceTelefon() {
        const uri = serverContextPath + `/api/spravauctu/kontakty/notifikace/telefon/enable`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * 
     *
     */
    static enableHromadneOsloveni() {
        const uri = serverContextPath + `/api/spravauctu/kontakty/notifikace/hromadne-osloveni/enable`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @param kontaktKodVO 
     * @return cz.marbes.eosp.controller.vo.TwoFactorOperationVO
     */
    static checkOvereniTelefonKod(kontaktKodVO) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/telefon/check`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kontaktKodVO, headers));
    }

    /**
     * 
     *
     * @param telefon 
     * @return cz.marbes.eosp.controller.vo.TwoFactorOperationVO
     */
    static getOvereniTelefonKod(telefon) {
        const uri = serverContextPath + `/api/spravauctu/kontakty/overeni/telefon/get`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, telefon, headers));
    }

}
